import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils, FileUtils } from '@shared/utils';
import { LsbApi, type DownloadInquiryAttachmentRequest } from '@shared/api';

interface DownloadInquiryAttachmentParams extends DownloadInquiryAttachmentRequest {
  name?: string;
}

const downloadInquiryAttachmentEffect = createEffect((request: DownloadInquiryAttachmentParams) => LsbApi.downloadInquiryAttachment(request));
const clearEvent = createEvent();

downloadInquiryAttachmentEffect.done.watch((result) => FileUtils.downloadFile(result.result, result.params.name ?? result.params.attachmentId));

const $loadingStore = createStore<boolean>(false)
  .on(downloadInquiryAttachmentEffect.pending, (_, data) => data)
  .on(downloadInquiryAttachmentEffect.fail, () => false)
  .on(downloadInquiryAttachmentEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(downloadInquiryAttachmentEffect, () => null)
  .on(
    downloadInquiryAttachmentEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while downloading Attachment. Please try again.').message,
  )
  .on(downloadInquiryAttachmentEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $downloadInquiryAttachmentStore = {
  events: {
    downloadInquiryAttachment: downloadInquiryAttachmentEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    error: $errorStore,
  }),
};
